import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = (isExternalOperator) => {
  const privateCustomerData = isExternalOperator
    ? ''
    : `
      lastName
      middleName
      gender
      birthdate
      accounts {
        id
        provider
        providerId
      }
    `;
  return gql`
    query Case($customerId: Int!) {
      customerCases(customerId: $customerId){
        id
        insertedAt
        updatedAt
        status
        activitiesCount
        description
        lastNonSystemMessage{
          id
          body
          insertedAt
        }
        activities {
          id
          channelType
          insertedAt
          duration
          requestType {
            id
            name
          }
          customer {
            ${privateCustomerData}
            id
            firstName
            vip
            description
            identified
            customInfo {
              label
              value
            }
          }
        }
      }
    }`;
};

function parse(item) {
  return {
    ...item,
    activities: item.activities.map((activity) => ({
      ...activity,
      type: activity.channelType,
      case: {
        id: item.id,
        description: item.description,
      },
    })),
  };
}

export default function getCustomerCases(customerId, isExternalOperator = false) {
  if (!customerId) {
    return undefined;
  }
  return apollo.client.query({
    query: query(isExternalOperator),
    fetchPolicy: 'network-only',
    variables: { customerId: parseInt(customerId, 10) },
  }).then((res) => res.data.customerCases.map(parse));
}
